import React from 'react';

import Button from '@react/react-spectrum/Button';
import Heading from '@react/react-spectrum/Heading';
import Link from '@react/react-spectrum/Link';
import StartIcon from '@react/react-spectrum/Icon/Launch';
import RegisterIcon from '@react/react-spectrum/Icon/CollectionAdd';
import RequestIcon from '@react/react-spectrum/Icon/Share';
import UpdateIcon from '@react/react-spectrum/Icon/Star';

import './QuickLinks.scss';

export default function QuickLinks() {
  return (
    <div className="quick-links">
      <section className="docs-links">
        <Heading variant="subtitle3">Quick Links</Heading>

        <div style={{ display: 'flex' }}>
          <QuickLink
            icon={<StartIcon size="S" />}
            content={
              <span>
                Not sure what it is and where to start? Try our
                <Link href="/docs/getting-started"> Getting Started</Link>{' '}
                guide.
              </span>
            }
          />
          <QuickLink
            icon={<RegisterIcon size="S" />}
            content={
              <span>
                Already have an AEP or Experience Cloud?{' '}
                <Link href="mailto:demosystem@adobe.com?subject=Adding new org to Demo System&body=I would like to add my org to Demo System. ORG ID: ..., Solutions: ...">
                  Register your environment
                </Link>{' '}
                and start building great demos.
              </span>
            }
          />

          <QuickLink
            icon={<UpdateIcon size="S" />}
            text="Do you want to present ACS using DX Mobile App? "
            content={
              <Link href="https://wiki.corp.adobe.com/display/demosystem/ACS">
                Check available ACS scenarios
              </Link>
            }></QuickLink>
        </div>
      </section>

      <section className="latest-updates">
        <Heading variant="subtitle3">Latest Updates</Heading>

        <div style={{ display: 'flex' }}>
          <QuickLink
            icon={<UpdateIcon size="S" />}
            content={
              <span>
                New Launch/AEP configuration available -{' '}
                <b>Retail 2.0 using WebSDK</b>
              </span>
            }
          />
          <QuickLink
            icon={<UpdateIcon size="S" />}
            content={
              <span>
                Learn{' '}
                <Link href="/docs/demonstrate-aep-on-customer-website">
                  how to demonstrate AEP on customer’s website
                </Link>{' '}
                using Standalone Profile 2.0.
              </span>
            }
          />
          {/* <QuickLink
            icon={<RequestIcon size="S" />}
            content={
              <span>
                Courious about <b>Mobile Experience Edge Extension</b>?
                <Link href="mailto:demosystem@adobe.com?subject=Testing Mobile Experience Edge Extension!&body=I would like to learn more about the new Mobile AEP Extension.">
                  {' '}
                  Contact us
                </Link>{' '}
                to try it today with our app.
              </span>
            }
          /> */}
        </div>
      </section>
    </div>
  );
}

function QuickLink({ icon, text, date, linkTitle, linkUrl, content }) {
  return (
    <div className="quick-link">
      <div className="icon">{icon}</div>
      <div className="text">
        {text}
        {content}
      </div>
      <div className="date">{date}</div>
    </div>
  );
}
